import isServer from '../isServer'

const isIOS = () =>
  !isServer() && /iPhone|iPod|iPad/gi.test(window.navigator.userAgent)

export default isIOS
